import React from 'react';
import {Container} from "react-bootstrap";

const About = () => {
    return (
        <div style={{padding: '60px 0'}}>
            <Container>
                <h1 className='text-center'>About Page</h1>
            </Container>
        </div>
    );
};

export default About;